import { render, staticRenderFns } from "./_products-analysis.vue?vue&type=template&id=725eb1df&scoped=true&"
import script from "./_products-analysis.vue?vue&type=script&lang=js&"
export * from "./_products-analysis.vue?vue&type=script&lang=js&"
import style0 from "./_products-analysis.vue?vue&type=style&index=0&id=725eb1df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725eb1df",
  null
  
)

export default component.exports